export default __webpack_public_path__ + "static/media/BG _ LooperGroup.3093f433.svg";